var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hj-gf-logo"},[_c('em',{class:_vm.showCollapse ? 'on' : '',on:{"click":_vm.handleShowMenu}},[_c('i',{staticClass:"i1"}),_c('i',{staticClass:"i2"}),_c('i',{staticClass:"i3"})]),_c('img',{attrs:{"src":require("@/assets/images/hj-logo.png")},on:{"click":_vm.onThemeConfigChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }